package com.example.mystybag.sharedmodels.project.requestModels

import com.example.mystybag.sharedmodels.AllCommands.VERIFY_USER
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class VerifyUserRequestModel(
    val userId              : Long                  = 0L,
    val cityId              : Long                  = 0L,
    val code                : String                = ""
): BaseRequestModel(api = VERIFY_USER)
